import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { FaMinus } from "react-icons/fa";
import Select, { components } from "react-select";
import { useTranslation } from "react-i18next";

const { SingleValue } = components;

const CustomSingleValue = ({ data, ...props }) => {
  return (
    <SingleValue {...props}>
      <div className="flex flex-row items-center w-full gap-3">
        {!props.selectProps.isFocused && !!data.icon && (
          <span style={{ lineHeight: 24 }} className="drop-shadow-md">
            {data.icon}
          </span>
        )}
        <span className="text-sm font-semibold">{data.label}</span>
      </div>
    </SingleValue>
  );
};
 
export default function InputRowItem({
  label,
  setSelectedLevel,
  onRemoveRow,
  className,
  selectedLevel,
  inputId,
  rowIndex,
  // customStyles,
  options,
  selectedOption,
  setSelectedOption,
  setShouldUpdate,
  errorMessages,
  height = 60,
  innerLabel,
  updateSelected=()=>{}
}) {
  const {t} = useTranslation();
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: inputId });
  const style = {
    transition,
    transform: CSS.Translate.toString({
      x: 0,
      y: transform?.y ?? 0
    }),
  };
const padding = innerLabel ? { paddingTop: 20 } : {};
 const customStyles = {
    control: (styles) => {
      return {
        ...styles,
        backgroundColor: "white",
        borderColor: errorMessages[rowIndex]?.level ? "red" : "#dfdfdf",
        // height: height,
        borderRadius: 6,
        minHeight: height,
        boxShadow: "none",
        "&:hover": {
          border: "1px solid #dfdfdf !important",
          cursor: "pointer",
        },
        paddingLeft: 8,
        ...padding,
      };
    },
    option: (provided) => {
      return {
        ...provided,
        padding: "8px 18px",
        zIndex: 2,
      };
    },
    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        color: "#aaaaaa",
      };
    },
    menu: (base) => {
      return {
        ...base,
        zIndex: 9999,
      };
    },
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menuList: (base) => ({
      ...base,
      "::-webkit-scrollbar": {
        width: "4px",
        height: "0px",
      },
      "::-webkit-scrollbar-track": {
        background: "rgba(255, 255, 255, 0.1)",
        borderRadius: "10px",
      },
      "::-webkit-scrollbar-thumb": {
        background: "#d1d1d1",
        borderRadius: "10px",
      },
      "::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
    }),
  };
  
  const levelOptions = [
  {
    label: t("Basic"),
    value: "Basic",
  },
  {
    label: t("Conversational"),
    value: "Conversational",
  },
  {
    label: t("Fluent"),
    value: "Fluent",
  },
];

  return (
    <div
      className="flex flex-row gap-3 outline-none"
      key={inputId}
      data-row-id={inputId}
      ref={setNodeRef}
      {...attributes}
      style={{...style, cursor: 'default'}}
    >
      <div className={"mt-14 md:mt-[1.375rem] cursor-move touch-none"}  {...listeners}>
        <svg
          width="11"
          height="18"
          viewBox="0 0 11 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.7">
            <circle cx="2" cy="2" r="2" fill="#333333" />
            <circle cx="9" cy="2" r="2" fill="#333333" />
            <circle cx="2" cy="9" r="2" fill="#333333" />
            <circle cx="9" cy="9" r="2" fill="#333333" />
            <circle cx="2" cy="16" r="2" fill="#333333" />
            <circle cx="9" cy="16" r="2" fill="#333333" />
          </g>
        </svg>
      </div>
      <div className="flex-1 relative flex flex-col md:flex-row md:items-center gap-3 mb-6 md:mb-0">
        <div className="flex-1 pt-2 md:pt-0">
          <div
            className={
              "font-semibold text-xs text-neutral-500 mb-2 md:hidden" 
              // + (rowIndex > 0 ? " md:hidden" : "")
            }
          >
            {t('language')}
          </div>
          <Select
            placeholder={t('language')}
            menuPortalTarget={document.body}
            styles={customStyles}
            options={options}
            value={selectedOption[inputId]}
            onChange={(value) => {
              setSelectedOption((s) => ({ ...s, [inputId]: value }));
              setShouldUpdate(true);
              updateSelected(value)
            }}
            components={{
              SingleValue: CustomSingleValue,
              IndicatorSeparator: () => null,
            }}
            className={`${className} ${label && "mt-2"}`}
          />
        </div>
        <div className="flex-1 relative">
          <div
            className={
              "font-semibold text-xs text-neutral-500 mb-2 md:hidden"
            }
          >
            {t('level')}
          </div>
          <div className="relative">
            <Select
              placeholder={t('level')}
              menuPortalTarget={document.body}
              styles={customStyles}
              options={levelOptions}
              value={selectedLevel[inputId]}
              onChange={(value) => {
                setSelectedLevel((s) => ({ ...s, [inputId]: value }));
                setShouldUpdate(true);
              }}
              components={{
                IndicatorSeparator: () => null,
              }}
              className={`text-sm ${className} ${label && "mt-2"}`}
            />
            {errorMessages[rowIndex]?.level && (
              <p className="input-error-message absolute left-0 top-full whitespace-nowrap">
                * {errorMessages[rowIndex]?.level}
              </p>
            )}
          </div>
        </div>

        <div
          className={
            "absolute md:relative top-0 right-0 md:mt-2" 
            // + (rowIndex === 0 ? " md:mt-[26px]" : "")
          }
        >
          <button
            className="h-6.5 w-6.5 bg-lightBlack rounded-full"
            onClick={() => onRemoveRow(inputId)}
          >
            <FaMinus className="m-auto text-white" />
          </button>
        </div>
      </div>
    </div>
  );
}
